import { apiClient } from "helpers/apiClient";

const API_BASE = process.env.REACT_APP_BUSINESS_MANAGEMENT_URL || "";

export const subscriptionService = {
  async getPlans() {
    try {
      return apiClient.get("/subscription/plans");
    } catch (error) {
      if (error.message.includes("Authorization") || error.message.includes("Unauthorized")) {
        const res = await fetch(`${API_BASE}/subscription/plans`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.message || "Failed to fetch plans");
        }
        
        return await res.json();
      }
      throw error;
    }
  },

  async createCheckout({ businessId, priceId }) {
    return apiClient.post("/subscription/checkout", { businessId, priceId });
  },

  async getSubscription(businessId) {
    return apiClient.get(`/subscription/${businessId}`);
  },

  async cancelSubscription(businessId) {
    return apiClient.post("/subscription/cancel", { businessId });
  },

  async getSubscriptionStatus() {
    return apiClient.get("/subscription-status/status");
  },

  async checkDashboardAccess() {
    return apiClient.get("/subscription-status/check-access");
  },

  async getDetailedSubscriptionInfo() {
    return apiClient.get("/subscription-status/details");
  },
};

export default subscriptionService; 